import { useState, useMemo } from "react";
import dayjs, { Dayjs } from "dayjs";

import { ReportSearch } from "../components/report/search";


interface UserSearchResult {
	SearchComponent: (loading?: boolean) => JSX.Element;
	searchQuery: SearchQuery;
}

interface SearchQuery {
	from: Date;
	to: Date;
	userId: string | undefined;
	timezone: string;
}

export const useSearch = (): UserSearchResult => {
	// TODO: refactor this repeated code
	const [from, setFrom] = useState<Dayjs>(dayjs(new Date()).startOf('day'));
	const [to, setTo] = useState<Dayjs>(dayjs(new Date()).endOf("day"));
	const [selectedUser, setSelectedUser] = useState<string | undefined>();
	const [timezone, setTimezone] = useState<string>('IST');
	// TODO: refactor this repeated code

	const handleOnSearch = (from: Dayjs, to: Dayjs, userId: string | undefined, tz?: string) => {
		setFrom(from);
		setTo(to);
		setSelectedUser(userId);
		setTimezone(tz || 'IST');
	};

	const SearchComponent = useMemo(() => {
		return (loading?: boolean) => <ReportSearch onSearch={handleOnSearch} loading={loading} />;
	}, []);

	return { SearchComponent, searchQuery: { from: from!.toDate(), to: to!.toDate(), userId: selectedUser, timezone } };
}